import moment from 'moment';
import { QueryBuilder, NotificationsNone } from '@mui/icons-material';
import { decreaseAlarmsCount, setAlarmAsRead } from 'app/store/alarmsSlice';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useThemeMediaQuery } from '@fuse/hooks';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DetailedTaskCard from 'src/app/main/apps/profile/tabs/ProfileTabs/DetailedTaskCard';

const MyNotificationItem = ({ notification }) => {
  const isPhone = useThemeMediaQuery((theme) => theme.breakpoints.down('md'));
  const { t } = useTranslation('translations');
  const dispatch = useDispatch();
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const navigate = useNavigate();

  const handleSetOpened = (e) => {
    e.stopPropagation();
    if (notification.alarmStatus === 0) {
      dispatch(setAlarmAsRead({ id: notification.id }));
      dispatch(decreaseAlarmsCount());
    }
  };

  const handleTaskClick = (taskId) => {
    setSelectedTaskId(taskId);
  };

  const closeTaskDetails = () => {
    setSelectedTaskId(null);
  };

  const processNotificationText = (notification) => {
    if (!notification) {
      return null;
    } else if (notification.senderSystemId === 5) {
      return notification.text.replace(
        /(https?:\/\/\S+)/g,
        `<a target="_blank" href="$1">(${t('Follow').toLowerCase()})</a>`
      );
    } else if (notification.senderSystemId === 6) {
      const textWithoutUrl = notification.text || t('ViewNews');
      return `${textWithoutUrl} <a data-news="1" style="cursor:pointer; color:#2563eb;">${t(
        'View'
      )}</a>`;
    } else if (notification.senderSystemId === 3) {
      const textWithoutUrl = notification.text || '';
      return `${textWithoutUrl} <a data-skud="1" style="cursor:pointer; color:#2563eb;">${t(
        'View'
      )}</a>`;
    } else if (notification.senderSystemId === 7) {
      let result = notification.text.replace(/https:.*$/, '');

      if (notification.link) {
        result += `: <a style="cursor:pointer; color:#6d7cea;" href="${notification.link}">${t(
          'View'
        )}</a>`;
      }

      return result;
    } else if (notification.senderSystemId === 9) {
      const urlMatch = notification.text.match(/https?:\/\/\S+/);
      const url = urlMatch ? urlMatch[0] : null;

      const textWithoutUrl = url ? notification.text.replace(url, '').trim() : notification.text;
      if (url) {
        return `${textWithoutUrl} <a style="cursor:pointer; color:#2563eb;" href="${url}">${t(
          'View'
        )}</a>`;
      }
      return textWithoutUrl;
    } else {
      return notification.text.replace(
        /(https?:\/\/[^\s]+\/board\/(\d+)\/view)/g,
        (_match, _fullUrl, boardId) =>
          `<button class="text-blue-600 underline" data-task-id="${boardId}">&nbsp;${t(
            'Open'
          )}</button>`
      );
    }
  };

  return (
    <>
      {notification && (
        <div
          className="flex hover:bg-blue-50 dark:hover:bg-lightblack border-b-1 py-5 gap-10 max-w-[300px] md:max-w-[500px]"
          onMouseEnter={handleSetOpened}
          onClick={(e) => {
            const button = e.target.closest('button[data-task-id]');
            if (button) {
              handleTaskClick(button.getAttribute('data-task-id'));
              return;
            }
            const newsLink = e.target.closest('a[data-news]');
            if (newsLink) {
              navigate('/');
              return;
            }
            const skudLink = e.target.closest('a[data-skud]');
            if (skudLink) {
              navigate('/apps/skud/absence-asks');
              return;
            }
            const link = e.target.closest('a');
            if (link && link.href && link.target !== '_blank' && !link.dataset.news) {
              e.preventDefault();
              try {
                const url = new URL(link.href);
                navigate(url.pathname + url.search + url.hash);
              } catch (error) {
                navigate(link.getAttribute('href')); // Fallback for relative paths
              }
            }
          }}
        >
          {!isPhone && (
            <div className="flex items-center w-32">
              <NotificationsNone className="text-grey-700 text-32 dark:text-white" />
            </div>
          )}
          <div className="flex flex-col">
            <div className="font-semibold text-grey-700 dark:text-white">
              {t(notification.senderSystem?.name)}
              {notification.alarmStatus === 0 && (
                <span className="py-2 ml-5 text-white rounded-full px-7 bg-red text-11">new</span>
              )}
            </div>

            {notification.text && (
              <div
                dangerouslySetInnerHTML={{
                  __html: processNotificationText(notification),
                }}
              />
            )}

            <div className="mt-5 text-grey-600">
              <QueryBuilder className="mb-3 mr-5 text-16" />
              <span className="text-12">
                {moment(notification.createdDate).format('DD.MM.YYYY HH:mm:ss')}
              </span>
            </div>
          </div>

          {selectedTaskId && (
            <DetailedTaskCard
              open={!!selectedTaskId}
              onClose={closeTaskDetails}
              taskId={selectedTaskId}
              title={t('TaskDetails')}
              isEditButtonVisible={false}
            />
          )}
        </div>
      )}
    </>
  );
};

export default MyNotificationItem;
